export const TRADE_ACTION_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'add', label: 'Add' },
  { value: 'close', label: 'Close' },
];

/** Side tab choices — Sell/Cover when closing (reduce-only), Long/Short when opening. */
export function sideTabsForAction(action) {
  if (String(action).toLowerCase() === 'close') {
    return [
      { value: 'short', label: 'Sell', hint: 'Close or reduce a long position' },
      { value: 'long', label: 'Cover', hint: 'Close or reduce a short position' },
    ];
  }
  return [
    { value: 'long', label: 'Long / Buy', hint: 'Open or add long' },
    { value: 'short', label: 'Short / Sell', hint: 'Open or add short' },
  ];
}

export function normalizeTradeAction(action) {
  const a = String(action || 'open').toLowerCase();
  if (a === 'reduce') return 'close';
  return TRADE_ACTION_OPTIONS.some((o) => o.value === a) ? a : 'open';
}

/** Resolve open vs close from an order row (multi-asset signal join or single-asset action column). */
export function resolveOrderAction(order) {
  if (!order) return 'open';
  const raw = String(order.signal_action ?? order.action ?? 'open').toLowerCase();
  if (raw === 'reduce') return 'close';
  if (Number(order.signal_reduce_only ?? order.reduce_only) === 1) return 'close';
  return raw;
}

/**
 * Human label for a trade — Long / Short on open; Sell when closing long; Cover when closing short.
 * `side` is the HL order direction (short order closes a long position, etc.).
 */
export function formatSideLabel(side, action) {
  const a = String(action || 'open').toLowerCase();
  const s = String(side || '').toLowerCase();
  if (a === 'close' || a === 'reduce') {
    return s === 'short' ? 'Sell' : 'Cover';
  }
  if (a === 'add') {
    return s === 'long' ? 'Long Add' : 'Short Add';
  }
  return s === 'long' ? 'Long' : 'Short';
}

export function orderSideDisplayLabel(order) {
  return formatSideLabel(order?.side, resolveOrderAction(order));
}

/** CSS class for coloring action labels in tables. */
export function sideLabelCssClass(side, action) {
  const label = formatSideLabel(side, action).toLowerCase();
  if (label === 'sell' || label === 'short' || label === 'short add') return 'short';
  if (label === 'cover') return 'cover';
  return 'long';
}

/** Badge text for an open position row (e.g. Long Open, Short Open). */
export function positionStatusLabel(side, action = 'open') {
  const s = String(side || '').toLowerCase();
  const a = String(action || 'open').toLowerCase();
  const sideWord = s === 'long' ? 'Long' : 'Short';
  if (a === 'add') return `${sideWord} Add`;
  return `${sideWord} Open`;
}

export function positionKey(p) {
  if (!p) return '';
  return p.lotKey || `${p.symbol}:${p.side}:${p.isPaper ? 'p' : 'l'}`;
}
